// quiron/frontend/src/components/ArenaQuiron.js

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getRankings, startQuiz } from '../api';
import QuizPlayer from './QuizPlayer';
import styles from './ArenaQuiron.module.css';

const ArenaQuiron = () => {
  const { t } = useTranslation();
  const [rankings, setRankings] = useState(null);
  const [userPosition, setUserPosition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quizQuestions, setQuizQuestions] = useState(null);
  const [quizMode, setQuizMode] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedSimulado, setSelectedSimulado] = useState(null);

  useEffect(() => {
    const fetchRankings = async () => {
      try {
        const data = await getRankings();
        setRankings(data.anonymous_rankings);
        setUserPosition(data.user_position);
      } catch (error) {
        console.error("Erro ao buscar rankings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRankings();
  }, []);

  const handleStartQuiz = async (specialty, mode) => {
    try {
        const data = await startQuiz(specialty, mode);
        setQuizQuestions(data.quiz_questions);
        setQuizMode(mode);
        setModalVisible(false); 
    } catch (error) {
        console.error("Erro ao iniciar o quiz:", error);
    }
  };

  const openModal = (simulado) => {
    setSelectedSimulado(simulado);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedSimulado(null);
  };

  if (quizQuestions) {
    return <QuizPlayer questions={quizQuestions} mode={quizMode} onFinish={() => setQuizQuestions(null)} />;
  }

  const simulados = {
    enamed: {
      title: t('simuladoEnamedTitle'),
      description: t('simuladoEnamedDescription'),
      details: t('simuladoEnamedDetails'),
      specialty: 'General',
      mode: 'enamed'
    },
    estudo: {
      title: t('simuladoEstudoTitle'),
      description: t('simuladoEstudoDescription'),
      details: t('simuladoEstudoDetails'),
      specialty: 'Cardiologia',
      mode: 'challenge'
    }
  };

  return (
    <div className={styles.arenaContainer}>
      {/* O h2 foi removido para evitar duplicidade com o título do AcademicManager */}
      <div className={styles.cardsContainer}>
        <div className={styles.card} onClick={() => openModal(simulados.enamed)}>
          <h3 className={styles.cardTitle}>{simulados.enamed.title}</h3>
          <p className={styles.cardDescription}>{simulados.enamed.description}</p>
        </div>
        <div className={styles.card} onClick={() => openModal(simulados.estudo)}>
          <h3 className={styles.cardTitle}>{simulados.estudo.title}</h3>
          <p className={styles.cardDescription}>{simulados.estudo.description}</p>
        </div>
      </div>

      {modalVisible && selectedSimulado && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>{selectedSimulado.title}</h3>
              <button className={styles.closeButton} onClick={closeModal}>×</button>
            </div>
            <div className={styles.modalBody}>
              <p>{selectedSimulado.details}</p>
            </div>
            <div className={styles.modalFooter}>
              <button 
                className={styles.startButton} 
                onClick={() => handleStartQuiz(selectedSimulado.specialty, selectedSimulado.mode)}
              >
                {t('startQuiz')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArenaQuiron;
